import { Injectable } from '@angular/core';

declare const AVACY: any; // definisce l’oggetto globale incluso in index.html

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor() { }

  /**
   * Apre il pannello preferenze cookie AVACY
   */
  openPreferences(position: 'absolute' | 'fixed' = 'absolute'): void {
    if (typeof AVACY?.showPreferenceCenter === 'function') {
      AVACY.showPreferenceCenter(position);
    } else {
      console.warn('AVACY non è ancora caricato.');
    }
  }

  /**
   * Reinizializza il banner o mostra il consenso
   */
  resetConsent(): void {
    if (typeof AVACY?.reset === 'function') {
      AVACY.reset();
    } else {
      console.warn('AVACY non è ancora caricato.');
    }
  }

  /**
   * Legge lo stato del consenso
   */
  getConsent(): any {
    try {
      return AVACY?.getConsent();
    } catch (e) {
      console.warn('Impossibile leggere il consenso AVACY.', e);
      return null;
    }
  }
}
